import AdminQuestionForm from '../../components/AdminQuestionForm';
import React from 'react';


export const AddExamQuestion = () => {
    return <AdminQuestionForm restartStateOnSave={true}/>
}

export default AddExamQuestion;
